import {constants} from '@ispm-client/modules/bpmn-modeler/constants/constants';

export class OverlayUtils {


  public static updateOverlayBounds(height, overlay) {
    if (overlay) {
      const overlayIconElement = overlay.htmlContainer;
      const overlayIcon = overlayIconElement.getElementsByClassName('neighborhood-overlay-container')[0];
      const newHeight = height + 2 + 'px';
      if (overlayIcon.style.height !== newHeight) {
        overlayIcon.style.height = newHeight;
        overlayIcon.style.paddingTop = (height / 2) - constants.NEIGHBORHOOD_OVERLAY_ICON_HEIGHT + 'px';
      }
    } else {
      console.error('overlay icon is undefined');
    }
  }

  public static setVisible(overlay, visible) {
    if (overlay) {
      overlay.htmlContainer.style.display = visible === false ? 'none' : '';
      overlay.htmlContainer.style.visibility  = visible === false ? 'hidden' : '';
    } else {
      console.warn('OverlayUtils - trying to change visibility of null overlay object');
    }
  }

  public static setVisibleAllOverlays(overlays, visible) {
    overlays.forEach(overlay => {
      OverlayUtils.setVisible(overlay, visible);
    });
  }
}
